import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import {
  Button,
  GridColumn,
  GridRow,
  Img,
  Loader,
  Utils,
} from "arv-reactcomponents";
import AddressBlockWrapper from "../AddressBlockWrapper";
import BackButton from "../BackButton";
import { RETURNS, Endpoints, Checkout } from "npmlinks-constants";

const { ADDRESS } = RETURNS;

@inject("AddressStore", "ReturnStore")
@observer
class AddressList extends Component {
  static renderLoader() {
    return (
      <div className="nw-bodyoverlay nw-addaddress-overlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }
  get loader() {
    return this.props.AddressStore.addressloader;
  }
  render() {
    const {
      addresses,
      forReturns,
      addAddress,
      onAddressSelection,
      onEditClick,
      onRemoveAddress,
      onSetAddressDefault,
      previous,
      showBackButton,
      doNotShowRemoveAddress,
    } = this.props;
    return (
      <Fragment>
        {(this.loader || this.props.showLocalLoader) && AddressList.renderLoader()}
        {addresses.length > 0 && (
          <GridRow>
            <GridColumn className="nw-addresslist-header">
              {showBackButton && (
                <BackButton.component
                  previous={previous}
                  className="nw-returns-backbtn"
                />
              )}
              <h2 className="nw-addresslist-title"> {ADDRESS.TITLE} </h2>
            </GridColumn>
            <GridColumn className="nw-addresslist-list">
              <Button
                className="nw-addresslist-addadrssbtnborder"
                onClick={addAddress}
              >
                <span className="nw-addresslist-addadrssbtntxt">
                  {" "}
                  {Checkout.CHECKOUT_BUTTON_TEXTS.ADD_ADDRESS}
                </span>
              </Button>
              {addresses.map(address => (
                <AddressBlockWrapper.component
                  className="nw-addresslist-addressblockwrapper"
                  address={address}
                  disabled={forReturns && !address.isReturnable}
                  key={address.id}
                  isDefault={address.isDefault}
                  onEditClick={onEditClick}
                  onRemoveAddress={onRemoveAddress}
                  onSelect={onAddressSelection}
                  onSetAddressDefault={onSetAddressDefault}
                  doNotShowRemoveAddress = {doNotShowRemoveAddress}
                />
              ))}
            </GridColumn>
          </GridRow>
        )}
        {!addresses.length && !this.props.showLocalLoader && (
          <GridRow>
            <GridColumn className="nw-addresslist-empty">
              {showBackButton && (
                <BackButton.component
                  previous={previous}
                  className="nw-returns-backbtn"
                />
              )}
              <h2 className="nw-addresslist-title"> {ADDRESS.TITLE} </h2>
              <div className="nw-addresslist-mapwrapper">
                <Img
                  className="nw-addresslist-map"
                  src={Endpoints.noAddressImage}
                  alt="map"
                />
              </div>
              <h2 className="nw-addresslist-title">{ADDRESS.NO_ADDRESS}</h2>
              <span className="nw-addresslist-description">
                {ADDRESS.START_SHOPPING}
              </span>
              <div className="nw-addresslist-addadrssbtnwrap">
                <Button
                  className="nwc-btn-primary nw-addresslist-addadrssbtn"
                  onClick={this.props.addAddress}
                >
                  {Checkout.CHECKOUT_BUTTON_TEXTS.ADD_ADDRESS}
                </Button>
              </div>
            </GridColumn>
          </GridRow>
        )}
      </Fragment>
    );
  }
}

AddressList.defaultProps = {
  addAddress: Utils.noop,
  onAddressSelection: Utils.noop,
  onEditClick: Utils.noop,
  onRemoveAddress: Utils.noop,
  onSetAddressDefault: Utils.noop,
  previous: Utils.noop,
  forReturns: false,
  showBackButton: false,
  showLocalLoader: false,
  doNotShowRemoveAddress: false,
};

AddressList.wrappedComponent.propTypes = {
  addresses: PropTypes.shape({}).isRequired,
  addAddress: PropTypes.func,
  onAddressSelection: PropTypes.func,
  onEditClick: PropTypes.func,
  onRemoveAddress: PropTypes.func,
  onSetAddressDefault: PropTypes.func,
  previous: PropTypes.func,
  forReturns: PropTypes.bool,
  showBackButton: PropTypes.bool,
  showLocalLoader: PropTypes.bool,
  doNotShowRemoveAddress: PropTypes.bool,
};

const getFinalComponent = component =>
  inject("AddressStore", "ReturnStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AddressList.wrappedComponent,
  component: AddressList,
};

export default ProjectComponent;
